//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { EthAddr } from '@shared/SchemaTypes'
import React, { CSSProperties, ReactElement } from 'react'
import { Box } from '@mui/material'
import { CurrencyExchange } from '@mui/icons-material'

import { urlForFile } from '@react/apx/AwsApx'
import { logOT } from '@shared/loggingShared'

import { useOtChainState } from '@react/redux/store'

export default function ViewLogo(props: {
  addrOrId: string | EthAddr
  style?: CSSProperties
  size: number
  skipBlank?: boolean
}): ReactElement {
  const { addrOrId } = props

  const {
    stageConfiguration: { stageName },
  } = useOtChainState()

  const [noLogo, setNoLogo] = React.useState<boolean>(false)

  const handleError = (): void => {
    logOT.trace('LOGO ERROR', addrOrId)
    setNoLogo(true)
  }

  if (!noLogo && stageName) {
    const url = urlForFile(stageName, `${addrOrId}/logo.png`)
    return (
      <img
        src={url}
        style={{ ...props.style, width: props.size, height: props.size }}
        onError={handleError}
        alt={addrOrId}
      />
    )
  } else if (addrOrId && addrOrId.startsWith('0x') && !props.skipBlank) {
    return (
      <Box
        sx={{
          width: props.size,
          height: props.size,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          border: '1px solid #e0e0e0',
          borderRadius: '40px',
          ...props.style,
        }}
      >
        <CurrencyExchange sx={{ color: '#9e9e9e', fontSize: '24px' }} />
      </Box>
    )
  } else {
    logOT.trace('NO LOGO', addrOrId)
    return (
      <Box
        sx={{
          width: props.size,
          height: props.size,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          border: '0px solid #e0e0e0',
          borderRadius: '40px',
          ...props.style,
        }}
      ></Box>
    )
  }
}
